"use client";

import Image from "next/image";

import { mergeClasses } from "@trex-2b/libs";

import { Button } from "@/components/button";

export type ContactSalesThanksCardProps = {
  className?: string;
  onTryDemo?: () => void;
};

export function ContactSalesThanksCard({
  className,
  onTryDemo,
}: ContactSalesThanksCardProps) {
  return (
    <div
      className={mergeClasses(
        "flex h-[562px] w-[497px] shrink-0 flex-col justify-between rounded-lg border border-solid border-[rgba(28,25,22,0.4)] bg-white px-6 pb-6 pt-[34px]",
        className,
      )}
    >
      <div className="flex w-full flex-col gap-6">
        <div className="relative size-[65px] shrink-0 overflow-hidden">
          <div className="absolute inset-[2.47%_6.35%_2.51%_6.35%]">
            <Image
              alt=""
              src={"/images/landing/contact-sale-smail.svg"}
              width={56}
              height={60}
              className="block size-full max-w-none object-contain"
            />
          </div>
        </div>
        <div className="flex w-full flex-col gap-[23px]">
          <div className="flex w-full flex-col gap-3 not-italic">
            <p className="whitespace-nowrap text-[28px] font-medium leading-[30.8px] tracking-[-0.3px] text-[#31373d]">
              {`Thanks — You’re In`}
            </p>
            <p className="min-h-10 w-full max-w-[449px] text-[14px] font-normal leading-normal text-[#4a4a4a]">
              We will be in touch with you within 5 working days via email to
              schedule a call for the topics below:
            </p>
          </div>
          <div className="w-full">
            <div className="text-[16px] font-medium leading-[36px] tracking-[0.14px] text-black">
              <p className="mb-0">· Analyze your current project strategy</p>
              <p className="mb-0">
                · Set the criteria that matters to your project
              </p>
              <p>· Recommend a growth plan</p>
            </div>
          </div>
        </div>
      </div>
      <Button
        type="button"
        variant="Fill"
        size="XL"
        fullWidth
        className="text-sm font-bold leading-5 tracking-[0.14px]"
        data-testid="contact-sales-thanks-try-demo-btn"
        onClick={onTryDemo}
      >
        Try demo (5 mins)
      </Button>
    </div>
  );
}
